// Trilingual translations: Spanish (es) / English (en) / Japanese (jp)

export const LANGS = ["es", "en", "jp"];

export const t = {
  nav: {
    services: { es: "Servicios", en: "Services", jp: "サービス" },
    portfolio: { es: "Portafolio", en: "Portfolio", jp: "ポートフォリオ" },
    courses: { es: "Cursos", en: "Courses", jp: "コース" },
    about: { es: "Sobre Abril", en: "About", jp: "アブリルについて" },
    contact: { es: "Contacto", en: "Contact", jp: "お問い合わせ" },
    book: { es: "Reservar", en: "Book Now", jp: "予約する" },
  },
  hero: {
    overline: {
      es: "Maquillista y peinadora profesional · Especialista en Novias",
      en: "Professional makeup artist & hair · Bridal specialist",
      jp: "プロのメイク&ヘア · ブライダル専門",
    },
    name: { es: "Abril Suarez", en: "Abril Suarez", jp: "アブリル スアレス" },
    kicker: {
      es: "Tu belleza es una herramienta de poder, úsala a tu favor.",
      en: "Your beauty is a tool of power — use it to your advantage.",
      jp: "あなたの美は、あなたを支える力。",
    },
    title: {
      es: "El poder de tu belleza.",
      en: "The power of your beauty.",
      jp: "美という力。",
    },
    sub: {
      es: "Maquillista en Aguascalientes, especialista en novias desde hace 4 años y certificada por Red Conocer.",
      en: "Makeup artist in Aguascalientes — bridal specialist for over 4 years, certified by Red Conocer.",
      jp: "アグアスカリエンテス拠点、4年以上のブライダル専門、Red Conocer認定メイクアップアーティスト。",
    },
    cta_book: { es: "Agenda tu cita", en: "Book your session", jp: "予約する" },
    cta_view: { es: "Ver portafolio", en: "View portfolio", jp: "作品を見る" },
  },
  services: {
    overline: { es: "01 — Servicios", en: "01 — Services", jp: "01 — サービス" },
    title: { es: "Cada servicio, una experiencia.", en: "Every service, an experience.", jp: "すべてのサービスが、ひとつの体験。" },
    from: { es: "Desde", en: "From", jp: "料金" },
    mxn: { es: "MXN", en: "MXN", jp: "MXN" },
    request: { es: "Solicitar", en: "Request", jp: "依頼する" },
  },
  portfolio: {
    overline: { es: "02 — Portafolio", en: "02 — Portfolio", jp: "02 — ポートフォリオ" },
    title: { es: "Trabajo seleccionado.", en: "Selected work.", jp: "セレクテッドワーク。" },
    filters: {
      all: { es: "Todo", en: "All", jp: "すべて" },
      editorial: { es: "Editorial", en: "Editorial", jp: "エディトリアル" },
      bridal: { es: "Novias", en: "Bridal", jp: "ブライダル" },
      events: { es: "Eventos", en: "Events", jp: "イベント" },
    },
  },
  courses: {
    overline: { es: "03 — Cursos", en: "03 — Courses", jp: "03 — コース" },
    title: { es: "Aprende con Abril.", en: "Learn with Abril.", jp: "アブリルから学ぶ。" },
    duration: { es: "Duración", en: "Duration", jp: "期間" },
    next_date: { es: "Próxima fecha", en: "Next date", jp: "次回開催" },
    spots: { es: "Cupo", en: "Spots", jp: "定員" },
    enroll: { es: "Reservar lugar", en: "Reserve a spot", jp: "申し込む" },
    price: { es: "Inversión", en: "Investment", jp: "受講料" },
  },
  about: {
    overline: { es: "04 — Sobre Abril", en: "04 — About Abril", jp: "04 — アブリルについて" },
    title: { es: "Formación, criterio y compromiso con la excelencia.", en: "Training, taste and a commitment to excellence.", jp: "研鑽と美意識、そして卓越へのこだわり。" },
    body: {
      es: "Soy Abril Suárez, maquillista profesional y licenciada en Mercadotecnia y Medios de Comunicación. Llevo 6 años construyendo una carrera basada en conocimiento, servicio y compromiso — con la cercanía como método y la excelencia como estándar. Sé que la imagen importa y que asistir a un evento carga con una responsabilidad enorme; ese peso lo asumo con cada clienta que pasa por mi silla.",
      en: "I'm Abril Suárez, a professional makeup artist with a degree in Marketing and Communications. Six years building a career grounded in knowledge, service and commitment — closeness as method, excellence as standard.",
      jp: "私はアブリル・スアレス。プロのメイクアップアーティストであり、マーケティング&コミュニケーション学士。6年にわたり、知識・サービス・献身を軸にキャリアを積んでいます。",
    },
    body2: {
      es: "Mi formación es continua: especialidades en Novias y Aerógrafo del Instituto Cristina Cuellar, master classes con referentes mundiales como Javier de la Rosa, Mushi y Luis Torres. Certificada por Red Conocer, y con la certificación ECO0057 como Evaluadora de Maquillistas. Actualmente enseño maquillaje en el Instituto de Belleza Francisco Gutiérrez y en cursos privados dentro de nuestro estudio Make Up AB.",
      en: "Continuously trained: Bridal & Airbrush at Instituto Cristina Cuellar, master classes with world references. Red Conocer certified, ECO0057 evaluator. Currently teaching at Instituto de Belleza Francisco Gutiérrez and at our Make Up AB studio.",
      jp: "継続的な研鑽:Cristina Cuellar校でブライダルとエアブラシを専攻、Javier de la Rosaら世界的巨匠のマスタークラスを修了。Red Conocer認定、ECO0057評価者。現在はFrancisco Gutiérrez校とMake Up ABスタジオにて指導。",
    },
    cta: { es: "Reservar consulta", en: "Book a consultation", jp: "コンサルティング予約" },
  },
  testimonials: {
    overline: { es: "05 — Testimonios", en: "05 — Testimonials", jp: "05 — お客様の声" },
    title: { es: "Sobre el trabajo.", en: "About the work.", jp: "作品について。" },
    items: [
      {
        quote: {
          es: "Abril entendió mi boda como nadie. Me sentí yo, sólo que radiante.",
          en: "Abril understood my wedding like no one else. I felt myself — but radiant.",
          jp: "アブリルは私の結婚式を誰よりも理解してくれました。輝く自分自身でいられました。",
        },
        author: "María Fernanda · Novia",
      },
      {
        quote: {
          es: "Una profesional impecable. Las fotos editoriales hablan por sí solas.",
          en: "An impeccable professional. The editorial photos speak for themselves.",
          jp: "完璧なプロフェッショナル。写真がすべてを物語っています。",
        },
        author: "Revista Pretty · Editorial",
      },
      {
        quote: {
          es: "El curso de automaquillaje me cambió la rutina. Recomendadísima.",
          en: "The self-makeup course changed my routine. Highly recommended.",
          jp: "セルフメイク講座で日々のメイクが変わりました。心からおすすめします。",
        },
        author: "Andrea L. · Aguascalientes",
      },
    ],
  },
  contact: {
    overline: { es: "06 — Hablemos", en: "06 — Let's talk", jp: "06 — お問い合わせ" },
    title: { es: "Hablemos.", en: "Let's talk.", jp: "お話ししましょう。" },
    sub: {
      es: "Cuéntame sobre tu evento o proyecto. Respondo en menos de 24 horas.",
      en: "Tell me about your event or project. I reply within 24 hours.",
      jp: "イベントやプロジェクトについてお聞かせください。24時間以内にご返信します。",
    },
    name: { es: "Nombre", en: "Name", jp: "お名前" },
    email: { es: "Email", en: "Email", jp: "メール" },
    message: { es: "Mensaje", en: "Message", jp: "メッセージ" },
    send: { es: "Enviar", en: "Send", jp: "送信" },
    success: { es: "¡Mensaje enviado! Te contactaré pronto.", en: "Message sent! I'll be in touch.", jp: "メッセージを送信しました。" },
    whatsapp: { es: "Escríbeme por WhatsApp", en: "Message on WhatsApp", jp: "WhatsAppで連絡" },
    instagram: { es: "@abrilsuamkp", en: "@abrilsuamkp", jp: "@abrilsuamkp" },
    location: { es: "Aguascalientes, México", en: "Aguascalientes, Mexico", jp: "メキシコ・アグアスカリエンテス" },
  },
  booking: {
    title: { es: "Agenda tu cita", en: "Book your session", jp: "ご予約フォーム" },
    sub: {
      es: "Envío tu solicitud por email y la registro en mi agenda. Te contacto en menos de 24 horas.",
      en: "I'll receive your request by email and register it in my calendar. I'll be in touch within 24 hours.",
      jp: "ご依頼を承りましたら、24時間以内にご連絡いたします。",
    },
    name: { es: "Nombre completo", en: "Full name", jp: "お名前" },
    email: { es: "Email", en: "Email", jp: "メール" },
    phone: { es: "Teléfono / WhatsApp", en: "Phone / WhatsApp", jp: "電話 / WhatsApp" },
    service: { es: "Servicio", en: "Service", jp: "サービス" },
    date: { es: "Fecha del evento", en: "Event date", jp: "ご希望日" },
    location: { es: "Ubicación", en: "Location", jp: "ロケーション" },
    message: { es: "Notas adicionales", en: "Additional notes", jp: "ご要望" },
    submit: { es: "Enviar solicitud", en: "Send request", jp: "送信する" },
    success: {
      es: "¡Solicitud enviada! Te llegará un correo de confirmación y te contactaré pronto.",
      en: "Request sent! You'll get a confirmation email and I'll be in touch.",
      jp: "ご依頼を承りました。確認メールをお送りします。",
    },
    services: {
      bridal: { es: "Maquillaje para Novias", en: "Bridal Makeup", jp: "ブライダルメイク" },
      editorial: { es: "Maquillaje Editorial", en: "Editorial Makeup", jp: "エディトリアルメイク" },
      events: { es: "Eventos de Belleza", en: "Beauty Events", jp: "ビューティイベント" },
      social: { es: "Eventos Sociales", en: "Social Events", jp: "ソーシャルイベント" },
      course: { es: "Curso", en: "Course", jp: "コース" },
    },
  },
  footer: {
    hablemos: { es: "Hablemos.", en: "Let's talk.", jp: "お話ししましょう。" },
    rights: { es: "Todos los derechos reservados.", en: "All rights reserved.", jp: "All rights reserved." },
    studio: { es: "Estudio en Aguascalientes · Servicio en todo México", en: "Studio in Aguascalientes · Service across Mexico", jp: "アグアスカリエンテスのスタジオ" },
  },
  admin: {
    login_title: { es: "Panel Privado", en: "Private Panel", jp: "管理画面" },
    email: { es: "Email", en: "Email", jp: "メール" },
    password: { es: "Contraseña", en: "Password", jp: "パスワード" },
    login: { es: "Entrar", en: "Sign in", jp: "ログイン" },
    logout: { es: "Salir", en: "Sign out", jp: "ログアウト" },
    bookings: { es: "Reservas", en: "Bookings", jp: "予約" },
    courses: { es: "Cursos", en: "Courses", jp: "コース" },
    gallery: { es: "Galería", en: "Gallery", jp: "ギャラリー" },
  },
};

export function tr(node, lang = "es") {
  if (!node) return "";
  if (typeof node === "string") return node;
  return node[lang] || node.es || "";
}
